import Agent from './agent'

const agent = new Agent()

export const sentEventGroupingService = {
  one: (params) => agent.get(`/send-event-layout`, { params }),
  update: (data) => agent.post(`/send-event-layout`, { data }),
}
